import React from "react";
import {
  ASSET_CLASSIFICATION_LABELS,
  AssetClassification,
} from "../../../api/credit_account_current_positions";

interface AssetClassificationPillProps {
  value?: AssetClassification | null;
}

const AssetClassificationPill: React.FC<AssetClassificationPillProps> = ({
  value,
}) => {
  const getBackgroundColor = (
    classification?: AssetClassification | null,
  ) => {
    switch (classification) {
      case AssetClassification.STANDARD:
        return "#DCFCE7";

      case AssetClassification.SMA_0:
      case AssetClassification.SMA_1:
      case AssetClassification.SMA_2:
        return "#FEF9C3";

      case AssetClassification.SUB_STANDARD:
      case AssetClassification.DOUBTFUL:
      case AssetClassification.LOSS:
        return "#FEE2E2";

      case AssetClassification.WRITTEN_OFF:
        return "#FECACA";

      case AssetClassification.OTHER:
      default:
        return "#F1F5F9";
    }
  };

  const label =
    value !== null && value !== undefined
      ? ASSET_CLASSIFICATION_LABELS[value] ?? String(value)
      : "--";

  return (
    <span
      className="inline-flex items-center justify-center rounded-[8px] border border-transparent px-2 py-[2px] font-sans text-xs font-medium leading-4 text-[#4B5563]"
      style={{ backgroundColor: getBackgroundColor(value) }}
    >
      {label}
    </span>
  );
};

export default AssetClassificationPill;